import React from "react";

export const Text = ({state, setState, setterArgs}) => (
    <input
        type="text"
        value={state}
        className='pl-3 pt-1 pb-1'
        onChange={e => {
            setState(e.target.value, setterArgs)
        }}
    />
)